import { ServiceMaker } from "./index"

export const listSourceBranches = () => ServiceMaker('inquiry/sourceBranches', 'GET')

export const listDestinationBranches = (sourceBranch:string) => ServiceMaker(`inquiry/destinationBranches/${sourceBranch}`, 'GET')

export const listB2BServices = (sourceBranch:string,destinationBranch:string,weight:any) => ServiceMaker(`inquiry/b2bservices?sourceBranch=${sourceBranch}&destinationBranch=${destinationBranch}&weight=${weight}`, 'GET')

export const listD2DServices = (sourcePincode:any,destinationPincode:any,weight:any) => ServiceMaker(`inquiry/d2dservices?sourcePincode=${sourcePincode}&destinationPincode=${destinationPincode}&weight=${weight}`, 'GET')